import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m652-140 60 60H220q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h372l208 239v487q0 14-7 29t-19 23L562-314q-20 12-40 17-19 5-42 5-62 0-104-42t-43-105q0-62 43-104t104-43q62 0 105 43t42 104q0 23-6 44t-20 37l139 139v-403L568-820H220v680h432ZM480-352q38 0 63-29t24-69q0-33-26-54t-61-22q-35 0-61 22t-26 54q0 39 25 69t62 29Zm0-98Zm0 0Z"/>',
  f: '<path d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h345q13 0 25 6t20 15l175 201q8 8 12 18t3 21v406q0 15-13 21t-25-5L601-358q13-16 20-37t6-44q0-62-42-104t-105-43q-62 0-104 43t-43 104q0 62 43 105t104 42q23 0 43-5t39-17l183 183q14 14 7 33t-28 18H220Zm260-272q-36 0-61-25t-26-62q0-36 26-61t61-26q36 0 62 26t25 61q0 36-25 62t-62 25Z"/>',
};

export default data;
